@import 'styles/variables';

.tabPanel {
  padding: 0;
  display: inline-block;
  vertical-align: top;
  height: 100%;
}

@media (min-width: $tabletPortraitMinWidth) {
  .tabPanel {
    padding: 24px 0 0 0;
  }
}
